export const API_BASE_URL = "https://api-aa.aivoria.nl";
// export const API_BASE_URL = "http://localhost:5000";
export const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50MB in bytes
export const MAX_TOTAL_SIZE_MB = 100;
export const MAX_FILE_MB = 50; //50MB in bytes

// export const CHAT_BASE_API_URL = "https://assistant-api-temp.aa.aivoria.nl"
export const CHAT_BASE_API_URL = "https://assistant-api.aivoria.nl"
// https://assistant-api.aivoria.nl
